import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import { environment } from '@env/environment';
import {CartPNRUpdateInt, SeatAirplanes, SeatMapsInt, SeatmapCollectionInt} from '@interfaces/';
import { SeatMapsMapper } from '@app/mappers/seat.mapper';
import { Observable, throwError } from 'rxjs';
import { CartMapper } from '@app/mappers/cart.mapper';
import { CartRequestPNRInt } from '@app/interfaces/cart.interface';
import { LoadingService } from './loading.service';
import { PASSENGER_TYPE, TypeLoading, PAX_TYPE } from "@app/enums";
import { Passenger } from "@app/models/micro";
import moment from "moment/moment";
import {GlobalsService} from '@services/globals.service';
import {ErrorAdapter} from "@models/adapter/error.adapter";
@Injectable({
  providedIn: 'root'
})
export class SeatsService {

  url = `${environment.urlApi}`;
  seatMap = null;
  private readonly bockInExitRow = [ PAX_TYPE.INFANT, PAX_TYPE.CHILD ]

  constructor(
    private http: HttpClient,
    private _loadingService: LoadingService,
    private global: GlobalsService,
  ) { }

  getSeatMap(cartId: string): Observable<SeatMapsInt[]> {
    const p = {
      cartId
    };

    const params = new HttpParams({ fromObject: p });
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);
    return this.http.get<SeatmapCollectionInt>(`${this.url}/seatmaps`, { params })
      .pipe(
        map((res) => {
          this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
          this.global.setSeatMapInfo(SeatMapsMapper.getSeatMaps(res));
          return SeatMapsMapper.getSeatMaps(res);
        }), catchError(this.handlerError.bind(this))
      );
  }

  findBlockPassenerInExitRow(type: PAX_TYPE ): boolean {
    return this.bockInExitRow.indexOf(type) > -1;
  }

  validateExitRowDisable(seat, passenger:  Passenger): boolean {
    let isBlock =  false;
    const { paxType, dateOfBirth } = passenger;
    const birthDay = moment(dateOfBirth);
    const sixtyYears = birthDay.clone().add(60, "years");
    const today =  moment();
    const isExitType = seat.seatType === "EXIT_ROW";

    if (isExitType) {
      if (passenger.hasInfant || paxType === PAX_TYPE.CHILD) {
        isBlock = true;
      }
      if (paxType === PAX_TYPE.ADULT && today.isSameOrAfter(sixtyYears)) {
        isBlock = true
      }
    }

    return isBlock;
  }

  getCarts(cartId: string, body: CartPNRUpdateInt) {
    const timeOfRequest = new Date().getTime().toString();
    const p = {
      timeOfRequest,
      pos: 'kiosk',
      store: 'MX',
      overrideTsa: 'true',
      overrideDocv: 'false',
      kioskId: 'ATOMEXK01',
      uiVersion: '4.5.19-109',
      location: 'MEX',
      currency: 'MXN',
      paymentEnabled: 'true'
    };

    const params = new HttpParams({ fromObject: p });
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);
    return this.http.put(`${this.url}/carts/${cartId}`, body, { params }).pipe(map(res => {
      this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
      return res;
    }), catchError(this.handlerError.bind(this)))
  }

  cartPnrUpdate(cartId: string, body: CartRequestPNRInt): Observable<CartRequestPNRInt> {
    const timeOfRequest = new Date().getTime().toString();
    const p = {
      timeOfRequest,
      pos: 'kiosk',
      store: 'MX',
      overrideTsa: 'true',
      overrideDocv: 'true',
      kioskId: 'ATOMEXK01',
      uiVersion: '4.5.19-109',
      languageUI: 'es_MX',
      location: 'MEX',
      currency: 'MXN',
      paymentEnabled: 'true'
    };

    const params = new HttpParams({ fromObject: p });
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);
    return this.http.put<CartRequestPNRInt>(`${this.url}/carts/${cartId}`, body, { params })
      .pipe(map((res) => {
        this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
        return CartMapper.cartPnrUpdate(cartId, res);
      }), catchError(this.handlerError.bind(this)));
  }

  getSeatByAirplane(plane: string) {
    return this.http.get(`../../assets/data/seatConfigs/${plane}.json`, {}).pipe(map((res) => res as SeatAirplanes));
  }



  aircraftTypeMap(aircraftType) {
    switch (aircraftType) {
      case "738":
        return "P166";
      case"7M7":
        return "P166";
      case "788":
        return "P7878";
      case "JC2":
        return "P180";
      case "7S8":
        return "P180";
      case "789":
        return "P7879";
      case "7M8":
        return "P180";
      case "7M9":
        return "P7379";
      case "E90":
        return "PE190";
      default:
        return aircraftType;
    }
  }

  handlerError(error: HttpErrorResponse) {
    this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
    const errorAdapt = ErrorAdapter.adapt(error?.error);
    return throwError(errorAdapt);
  }
}
